import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Label, Input, FormFeedback } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import CanalSelect from "../Procedimiento1/CanalSelect.js"
import DetailEmpresas from "../../clientes/Empresas/Detail.js"

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            empresa: null,
            canal: null,
            ltp: null,
            lte: null,
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
    }

    resetState() {
        this.setState({
            empresa: null,
            canal: null,
            ltp: null,
            lte: null,
        })
    }

    setSelects(data) {
        this.setState({
            empresa: data.empresa_id,
            canal: data.canal_id,
            ltp: data.ltp_id,
            lte: data.lte_id,
        });
        
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.solicitudes.detail}
                id={this.props.id}
                successMessage={""}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Solicitud"}
                buttonTitle={"Ver Solicitud"}
                buttonIcon={"fa fa-search fa-lg"}
                
                saveButton={false}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}
                className={"ui-modal-dialog ui-modal-lg"}
            >
                <div className="ui-form">
                    <div className="ui-section-grid">
                        <section className="ui-section-block">
                            <p className="ui-section-label">Identificación</p>
                            <div className="ui-row-2">
                                <div className="ui-field">
                                    <Label>Código</Label>
                                    <Input type="text" name="codigo" disabled={true} />
                                    <FormFeedback />
                                </div>
                                <div className="ui-field">
                                    <Label>Título</Label>
                                    <Input type="text" name="nombre" disabled={true} />
                                    <FormFeedback />
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Canal</Label>
                                    <CanalSelect value={this.state.canal} disabled={true} />
                                    <FormFeedback />
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Empresa/Organización</Label>
                                    <ParadigmaAsyncSeeker Detail={DetailEmpresas} fieldName={"empresa_id"} url={api.clientes.empresas.select} value={this.state.empresa} disabled={true} />
                                    <FormFeedback />
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block">
                            <p className="ui-section-label">Responsables</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Líder Técnico Proyecto</Label>
                                    <ParadigmaAsyncSeeker disabled={true} fieldName={"ltp_id"} url={api.usuarios.usuarios.select} value={this.state.ltp} />
                                    <FormFeedback />
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Líder Técnico Empresa</Label>
                                    {
                                        this.state.empresa != 0 &&
                                        <ParadigmaAsyncSeeker disabled={true} fieldName={"lte_id"} nombreField={"fullname"} url={api.clientes.responsables.select + "?tipo=1&empresa_id=" + this.state.empresa} value={this.state.lte} />
                                    }
                                    <FormFeedback />
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block ui-section-compact">
                            <p className="ui-section-label">Detalle</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Detalle</Label>
                                    <Input rows={5} type="textarea" name="detalle" disabled={true} />
                                    <FormFeedback />
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block ui-section-compact">
                            <p className="ui-section-label">Observaciones</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Observaciones</Label>
                                    <Input rows={5} type="textarea" name="observaciones" disabled={true} />
                                    <FormFeedback />
                                </div>
                            </div>
                        </section>
                    </div>
                </div>

            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento6/Detail.js